<template>
  <button 
    class="back-button" 
    @click="goBack"
    aria-label="Go back"
  >
    <IconArrowRight class="arrow-icon" />
  </button>
</template>

<script setup>
import IconArrowRight from '@/assets/svg/ArrowRight.vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const goBack = () => {
  router.back();
};
</script>

<style scoped>
.back-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.back-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
  transform: scale(1.05);
}

.arrow-icon {
  width: 24px;
  height: 24px;
  color: #666;
  transition: color 0.3s ease;
}

.back-button:hover .arrow-icon {
  color: #333;
}
</style>

